import React from "react";
import { LoadingIcon } from "components/Icons";
import { useSessionCtx } from "utils";

export const Spinner = ({ id, ...props }) => {
  const { debug } = useSessionCtx();
  if (id) {
    debug("SPINNER__id: ", id);
  }
  return (
    <div data-testid="spinner">
      <LoadingIcon {...props} />
    </div>
  );
};

export const SectionSpinner = (props) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Spinner size="10vw" {...props} />
  </div>
);

export const FullPageSpinner = (props) => (
  <div
    style={{
      width: "100%",
      height: "100vh",
      maxHeight: "480px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Spinner {...props} size="20vh" />
  </div>
);
